import cn from "classnames";
import React from "react";

import { getSafeErrorText } from "../../../helpers/safeRender";
import { useListingEditReadOnly } from "../../../contexts/listingEditContext";
import styles from "./textarea.module.css";

const TextArea = ({
  classNameWrap,
  className,
  ariaInvalid,
  describedBy,
  error,
  errorId,
  disabled,
  readOnly,
  id,
  isInvalid,
  name,
  maxLength,
  onChange,
  onBlur,
  label,
  labelClass,
  placeholder,
  required,
  styleProps,
  value
}) => {
  const contextReadOnly = useListingEditReadOnly();
  const isReadOnly = readOnly || contextReadOnly;
  const hasErrorText = Boolean(errorId && isInvalid);
  // `describedBy` is an always-on hint; `ariaInvalid` lets a caller that shows its own error text mark the field invalid.
  const describedByIds = [describedBy, hasErrorText ? errorId : undefined].filter(Boolean).join(" ");

  return (
    <div className={cn(styleProps?.wrapper, classNameWrap)}>
      {label && (
        <label className={cn(styles.label, labelClass)} htmlFor={id}>
          {label} {required && <span className={styles.asterisk}>*</span>}
        </label>
      )}
      <textarea
        className={cn(
          styles.input,
          styleProps?.inputBase,
          className,
          { [styles.invalid]: isInvalid },
          isInvalid ? styleProps?.inputInvalid : styleProps?.inputValid
        )}
        disabled={disabled}
        readOnly={isReadOnly}
        id={id}
        aria-invalid={hasErrorText || ariaInvalid ? true : undefined}
        aria-describedby={describedByIds || undefined}
        name={name}
        maxLength={maxLength}
        value={value}
        onBlur={onBlur}
        onChange={isReadOnly ? undefined : onChange}
        placeholder={placeholder}
      />
      {isInvalid && (
        <div id={errorId} className={cn(styles.error, styleProps?.error)}>
          {getSafeErrorText(error)}
        </div>
      )}
    </div>
  );
};

export default TextArea;
